import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { DermaplaningWaxingHero } from '../components/dermaplaning-waxing/DermaplaningWaxingHero';
export function DermaplaningWaxingPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2510">
      <Navigation data-id="element-2511" />
      <main data-id="element-2512">
        <DermaplaningWaxingHero data-id="element-2513" />
      </main>
      <Footer data-id="element-2514" />
    </div>;
}